module.exports = __webpack_public_path__ + "img/papier-dechire-haut.0c083241.png";